import { ClientesService2 } from '@core/services/clientes.service';
import { VisitsImportantInfoComponent } from './modals/visits-important-info/visits-important-info.component';
import { Component, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import { Router } from "@angular/router";
import * as toastr from "toastr";
import { State, City, Districts } from "@shared/models";
import { Utilservice } from "@core/services/util.service";

import { Visit } from "../../models/visit.interface";
import { VisitasService } from "../../services/visitas.service";
// import { ClientesService } from "../../../clientes/services/clientes.service";

import {CanSaveVisitsService} from './services/can-save-visits.service'

import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: "app-cadastro",
  templateUrl: "./cadastro.component.html",
  styleUrls: ["./cadastro.component.css"],
  providers: [CanSaveVisitsService]
})
export class CadastroComponent implements OnInit {
  scheme: string = "checkbox";
  lsStates: State[];
  selectedState: number;
  isSelectedAll = false;

  isRequesting: boolean = false;
  isFormFiltersRequesting: boolean = false;
  isFormVisitRequesting: boolean = false;

  isRequestingStates: boolean = false;
  isRequestingCities: boolean = false;
  isRequestingDistricts: boolean = false;
  visitaTransmitidaBool: boolean = false;

  lsCities: City[];
  selectedCity: number;

  lsDaysWithoutMovement: number[] = [10, 30, 60, 90, 120];
  selectedDaysWithoutMovement: number;
  selectedFormaConsulta: number;

  lsDistricts: Districts[];
  selectedDistrict: string;

  lsVisits: Visit[] = [];
  lsVisitsChecked = [];
  lsVisitsInDulorenNextWeekNotChecked = [];
  lsCliDuplicatasAtraso = [];

  diasSemana = [];
  diasSemanaTimestamp: number[] = [];
  visitDay = [];
  lsVisitComOrder = [];
  lsAlertas = [];
  lsFormasVisitas = [];

  rowModal;
  // rowModal2;
  userLogado;
  ordemVisita = [];

  visitsWithInportantInfo: Visit[] = [];

  @ViewChild(VisitsImportantInfoComponent, {static: true}) visitsImportantInfoComponent: VisitsImportantInfoComponent;

  constructor(
    private visitService: VisitasService,
    private router: Router,
    private canSaveVisitService: CanSaveVisitsService,
    private clientesService: ClientesService2,
    private cd: ChangeDetectorRef // Adicionado aqui
    // private clienteServiceDeb: ClientesService,
    ) {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
    this.isRequestingStates = true;

    this.visitService
      .getStates(this.userLogado.idSetor)
      .subscribe(
        data => (this.lsStates = data),
        error => console.log(error),
        () => (this.isRequestingStates = false)
      );

    this.getSemana();

    if (localStorage.getItem("clienteMovimentacao")) {
      const clienteMovimentacao = JSON.parse(
        localStorage.getItem("clienteMovimentacao")
      );

      localStorage.removeItem("clienteMovimentacao");

      this.lsVisits = clienteMovimentacao;

      this.lsVisits.forEach(e => {
        (e.cnpj = e.cnpj.toString()),
          (e.cep = e.cep.toString()),
          this.ordemVisita.push("");
      });

      this.lsVisitsChecked = clienteMovimentacao;

      this.makeVisit();
    }

    this.getFormasVisitas();
  }

  ngOnInit() {}

  filterCities(filterVal: any) {
    this.clearCitiesDistricts();

    this.selectedFormaConsulta = 0;

    if (filterVal === "undefined") return;

    this.isFormFiltersRequesting = true;
    this.isRequestingCities = true;
    this.visitService
      .getCities(this.selectedState, this.userLogado.idSetor)
      .subscribe(
        data => {
          this.lsCities = data;
          this.lsDistricts = [];
          this.isFormFiltersRequesting = false;
        },
        error => console.log(error),
        () => (this.isRequestingCities = false)
      );
  }

  filterDistricts(filterVal: any) {
    this.clearGrid();
    if (filterVal === "undefined") return;
    this.isFormFiltersRequesting = true;
    this.isRequestingDistricts = true;
    this.visitService
      .getDistricts(this.selectedCity, this.userLogado.idSetor)
      .subscribe(
        data => {
          this.isFormFiltersRequesting = false;
          this.lsDistricts = data;
        },
        error => console.log(error),
        () => (this.isRequestingDistricts = false)
      );
  }

  searchItems() {
    let f = [
      this.selectedState,
      this.selectedCity,
      this.selectedDistrict,
      this.selectedDaysWithoutMovement,
      this.selectedFormaConsulta

    ];

    this.visitDay = [];
    this.scheme = "checkbox";
    this.lsVisitsChecked = [];
    this.ordemVisita = [];
    this.lsVisitComOrder = [];

    this.isRequesting = true;
    this.visitService
      .getVisitsByParamsNewFilter(
        this.userLogado.id,
        this.selectedState,
        this.selectedCity,
        this.selectedDistrict,
        this.selectedDaysWithoutMovement,
        this.selectedFormaConsulta
      )
      .finally(() => (this.isRequesting = false))
      .subscribe(
        data => {
          console.log("data", data);
          this.lsVisits = data;

          this.lsVisits.forEach(e => {
            (e.cnpj = e.cnpj.toString()),
              (e.cep = e.cep.toString()),
              this.ordemVisita.push("");
          });

          this.isRequesting = false;
        },
        error => {
          console.log(error);
          this.isRequesting = true;
        },
        () => console.log("Get States")
      );
  }

  getVisitDate(id) {
    const visitDay = this.visitDay;

    if (visitDay.find(value => value.idCliente === id)) {
      return visitDay.find(value => value.idCliente === id).day;
    }

    return "";
  }

  isVisitSelected(visit) {
    const selected = this.lsVisitsChecked;

  // Verifica se há duplicatas e, se houver, busca o cliente correspondente
  if (this.lsCliDuplicatasAtraso.length > 0) {
    const clienteEncontrado = this.lsCliDuplicatasAtraso.some(cliente => cliente.idCliente === visit.idCliente);
    
    // Se o cliente foi encontrado na lista de duplicatas, verifica se ele está selecionado
    if (clienteEncontrado) {
      // this.lsVisitsChecked.splice(selected.indexOf(visit), 1);

      return false;
    }
  }

  // Se não houver duplicatas ou o cliente não for encontrado, apenas verifica se está selecionado
  return selected.indexOf(visit) >= 0;
  }

  onVisitChange(event, visit) {
    const selected = this.lsVisitsChecked;
    const selectedIndex = selected.indexOf(visit);

    if (selectedIndex === -1) {
      selected.push(visit);
    } else {
      selected.splice(selectedIndex, 1);
    }

    this.lsVisitsChecked = selected;
  }

  onDayChange(event, visit, i) {
    const target = event.target;

    visit.novaDataVisita = target.value;

    this.lsVisitsChecked[i].day = target.value;
  }

  onVisitaChange(event, i) {
    const idFormaVisita = event.target.value;

    this.lsVisitsChecked[i].idFormaVisita = idFormaVisita; //a lista recebe o id da forma de visita
  }

  DesableInputOrder(index){
    if(typeof this.lsVisitsChecked[index].day === 'undefined') {
      return true;
    } else {
      return false;
    }
  }

  visitAll() {
    if (this.isSelectedAll) {
      this.lsVisitsChecked = [];
    } else {
      this.lsVisits.map(visit => {
            this.lsVisitsChecked.push(visit);
      });
      //this.lsVisitsChecked = this.lsVisits;
    }

    this.isSelectedAll = !this.isSelectedAll;
  }

  isDataPrevInSemana(item: any, start: moment.Moment, end: moment.Moment): boolean {
    if (!item.dataPrev) return false;

    // tenta formato brasileiro
    let dataPrev = moment(item.dataPrev, "DD/MM/YYYY HH:mm:ss", true);

    // se falhar, tenta ISO (moment consegue ler naturalmente)
    if (!dataPrev.isValid()) {
        dataPrev = moment(item.dataPrev);
    }

    if (!dataPrev.isValid()) return false;

    return dataPrev.isSameOrAfter(start) && dataPrev.isSameOrBefore(end);
  }


  handleMarkVisitClick(){
    let trSemanaBool = false;

    const start = moment(this.diasSemana[0], "DD/MM/YYYY");
    const end = moment(this.diasSemana[this.diasSemana.length - 1], "DD/MM/YYYY");

    // this.lsVisitsChecked = this.lsVisitsChecked.filter(x => x.idStatusVisita !== 18);
    // this.lsVisitsChecked = this.lsVisitsChecked.filter(x => 
    //                         x.idStatusVisita !== 18 &&
    //                         this.isDataPrevInSemana(x, start, end)
    // );

    let lengthListSelect: number = this.lsVisitsChecked.length;

    const novaLista = [];

    for (let i = 0; i < this.lsVisitsChecked.length; i++) {

        const item = this.lsVisitsChecked[i];

        // 1️⃣ Primeiro verifica a data
        const ehDaSemana = this.isDataPrevInSemana(item, start, end);

        // ❌ Se NÃO for da semana → entra na lista direto
        if (!ehDaSemana) {
            novaLista.push(item);
            continue; // vai para o próximo item
        }
        else{
          // ✔ Se for da semana → verificar o idStatusVisita
          if (item.idStatusVisita == 18) {
              trSemanaBool = true;
              this.visitaTransmitidaBool = trSemanaBool;
          }

          novaLista.push(item);
          
        }
    }

    this.lsVisitsChecked = novaLista;

    // if(this.lsVisitsChecked.length == 0){
    //   toastr.error("Não é possível alterar visita transmitida na semana, para reprogramar visita, faça no lançamento do status!");

    //   return;
    // }
    
    // if(novaLista.length < lengthListSelect){
    //   toastr.info("Alguns clientes foram removidos, pois já existe agendamento dentro da semana. Para reprogramar visita, faça no lançamento do status!");
    // }

    this.isRequesting = true;

    if (this.lsCliDuplicatasAtraso.length > 0) {
      // Filtra a lista `lsVisitsChecked`, removendo os itens que têm o mesmo idCliente que existe na lista `lsCliDuplicatasAtraso`
      this.lsVisitsChecked = this.lsVisitsChecked.filter(visit => {
        return !this.lsCliDuplicatasAtraso.some(cliente => cliente.idCliente === visit.idCliente);
      });
    }

    this.lsCliDuplicatasAtraso = null;

    this.clientesService.possuiImportantesInfos({
      clientes: this.lsVisitsChecked.map(item => item.idCliente)
    }).subscribe(
      clientesComImportantesInfo => {
        if(clientesComImportantesInfo.length > 0){
          this.visitsWithInportantInfo = this.lsVisits.filter(visit => clientesComImportantesInfo.some(clientId => visit.idCliente === clientId));
          
          // Forçar detecção de mudanças antes de abrir o modal
          this.cd.detectChanges();
          
          this.visitsImportantInfoComponent.open()
        } else{
          this.makeVisit()
        }
      },
      error => {},
      () => this.isRequesting = false
    )
  }

  makeVisit() {
    this.scheme = "select";

    //this.lsVisitsChecked.map(item => item.inOrder = null)

    this.lsVisitsInDulorenNextWeekNotChecked = this.lsVisits.filter(e=> (
      Utilservice.dateIsInDulorenNextWeek(
        this.diasSemanaTimestamp,
        e.dataPrev,
        "DD/MM/YYYY"
      )
    ))

    this.lsVisitsInDulorenNextWeekNotChecked = this.lsVisitsInDulorenNextWeekNotChecked.map(item => ({...item}))

    this.lsVisitsChecked.map(item => {
      if(
        Utilservice.dateIsInDulorenNextWeek(
          this.diasSemanaTimestamp,
          item.dataPrev,
          "DD/MM/YYYY"
        )
      ){
        item.edicao = true,
        item.novaDataVisita = item.dataPrev,
        item.day =item.dataPrev
      }
    });


    this.lsVisits = this.lsVisitsChecked;
  }

  verifyDate(v) {
    //proxima Semana
    let start = moment(this.diasSemana[0], "DD/MM/YYYY");
    let end = moment(this.diasSemana[this.diasSemana.length - 1], "DD/MM/YYYY")
    let dataPrev = moment(v.dataPrev, "DD/MM/YYYY");

    if (dataPrev.isSameOrAfter(start) && dataPrev.isSameOrBefore(end)) {
      return false;
    } else {
      return true;
    }
  }

  formatCep(cep: String) {
    return Utilservice.formatCep(cep);
  }

  getSemana() {
    this.visitService.getProximaSemana().subscribe(
      data => {
        this.diasSemanaTimestamp = data;
        this.diasSemana = Utilservice.formatTimestampToString(data);
        console.log("dias", data);
      },
      error => console.log(error)
    );
  }

  private campoPreenchido(valor: any): boolean {
    return valor !== null &&
           valor !== undefined &&
           valor.toString().trim() !== "";
  }

  saveVisit() {
    const canSaveVisit = this.canSaveVisitService.execute(
      this.lsVisitsChecked,
      this.diasSemanaTimestamp
    )

    if (canSaveVisit) {
      let data = [];

      const visitaInvalida = this.lsVisitsChecked.find(v =>
        !this.campoPreenchido(v.kmCidade) &&
        !this.campoPreenchido(v.kmViajante)
      );

      if (visitaInvalida) {
        toastr.error("Existem visitas sem KM Cidade ou KM Viajante preenchidos, informe um por favor!");
        return;
      }

      this.lsVisitsChecked.forEach(element => {
        const DtPrevVisita = moment(element.dataPrev, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD')

        let novaDataVisita = '';

        if(element.novaDataVisita){
          novaDataVisita = moment(element.novaDataVisita, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD')
        }

        const visita = {
          IdFilialEmpr: 1,
          IdCli: element.idCliente,
          DtPrevVisita: element.edicao ? DtPrevVisita : novaDataVisita,
          IdStatusVisitaCli: 17,
          DtIncl: new Date().toISOString(),
          InVisitaPrev: "S",
          IdSetorComc: this.userLogado.idSetor,
          IdVnd: this.userLogado.id,
          InOrder: parseInt(element.inOrder),
          IdFormaVisita: element.idStatusVisita,
          KmCidade: element.kmCidade,
          KmViajante: element.kmViajante
          // IdFormaVisita: element.idFormaVisita
        }

        if(element.novaDataVisita){
          data.push({
            visita,
            edicao: element.edicao,
            novaDataVisita
          });
        }else{
          data.push({
            visita,
            edicao: element.edicao
          });
        }


      });

      let params = {
        visitas: []
      };
      params.visitas = data;

    //   const kmCidadePreenchido =
    //   visita.KmCidade !== null &&
    //   visita.KmCidade !== undefined &&
    //   visita.KmCidade.toString().trim() !== "";

    // const kmViajantePreenchido =
    //   visita.KmViajante !== null &&
    //   visita.KmViajante !== undefined &&
    //   visita.KmViajante.toString().trim() !== "";

    // if (!kmCidadePreenchido && !kmViajantePreenchido) {
    //   alert("Informe o KM Cidade ou KM Viajante.");
    //   return;
    // }

      this.isFormVisitRequesting = true;

      if(this.visitaTransmitidaBool){
        this.visitService.IncluirVisitaSemApagarAnterior(params).subscribe(
          data => {
            this.isFormVisitRequesting = false;
            toastr.success("Visita marcada com sucesso");
            this.router.navigateByUrl('/visitas/home');
            this.visitaTransmitidaBool = false;
          },
          error => {
            console.log(error);
            this.isFormVisitRequesting = false;

            if(typeof error === 'string'){
              toastr.error(error);
            }else{
              toastr.error("Falha ao salvar a visita");
            }
            // this.visitaTransmitidaBool = false;

          },
          () => console.log("Get States")
        );
      }
      else{
        this.visitService.saveVisita(params).subscribe(
          data => {
            this.isFormVisitRequesting = false;
            toastr.success("Visita marcada com sucesso");
            this.router.navigateByUrl('/visitas/home');
            this.visitaTransmitidaBool = false;
          },
          error => {
            console.log(error);
            this.isFormVisitRequesting = false;

            if(typeof error === 'string'){
              toastr.error(error);
            }else{
              toastr.error("Falha ao salvar a visita");
            }
            this.visitaTransmitidaBool = false;

          },
          () => console.log("Get States")
        );
      }
      

      console.log(this.visitDay);
    }
  }

  clearCitiesDistricts() {
    this.lsCities = [];
    this.selectedCity = void 0;
    this.lsDistricts = [];
    this.selectedDistrict = void 0;
  }

  clearForm() {
    this.selectedState = void 0;
    this.clearCitiesDistricts();
    this.lsVisits = [];
    this.isRequesting = false;
    this.isFormFiltersRequesting = false;
  }

  setRow(row) {
    this.visitService
      .getClienteById(row.idCliente)
      .subscribe(resp => (this.lsAlertas = resp), error => console.log(error));
    this.rowModal = row;
  }

  // searchDebitos(row2) {
  //   this.rowModal2 = row2;
  // }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  fomatDate(date) {
    return Utilservice.formatDate(date);
  }

  dateIsInDulorenNextWeek(date){
    return Utilservice.dateIsInDulorenNextWeek(
      this.diasSemanaTimestamp,
      date,
      'DD/MM/YYYY'
    )
  }

  showOrNotDataAgendamentoFormated(date: string){
    if(!date){
      return '';
    }

    const dateFormated =  Utilservice.formatDate(date);


    if(!this.dateIsInDulorenNextWeek(date)){
      return '';
    }

    return dateFormated;
  }

  formatDateToShow(date){
    if(!date) return '';
    return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY')
  }

  clearGrid() {
    this.lsVisits = [];
  }

  getFormasVisitas() {
    this.visitService.getFormasVisitasAtivas().subscribe(
      resp => {
        this.lsFormasVisitas = resp;
      },
      error => console.log(error)
    )
  }

  cancelClickPopUp(listcnpj: any){
    console.log("Chamou o cancelar do POPUP", listcnpj);

    this.lsCliDuplicatasAtraso = listcnpj;

    let data = [];

    listcnpj.forEach(element => {
      const  statusVisitaProvisoria = {
        IdStVisitaProvisoriaCliente: 0,
        IdVnd: this.userLogado.id,
        IdCli: 123,
        DsStVisitaProvisoriaCliente: "cancelado",
        Cnpj:element.cnpj
      }

      data.push(statusVisitaProvisoria);
    });

    console.log("ArrayPreenchido", data);

    //SALVAR DADOS DA VISITA CANCELADA
    this.visitService.saveStatusVisitaProvisoriaCliente(data).subscribe(
      data => {
        this.isFormVisitRequesting = false;
        toastr.success("Status de visita provisória salvo com sucesso");
        //this.router.navigateByUrl('/visitas/home');

        // this.searchItems();

        this.isRequesting = false;
      },
      error => {
        this.isFormVisitRequesting = false;

        if(typeof error === 'string'){
          toastr.error(error);
        }else{
          toastr.error("Status de visita provisória já cadastrado para o cliente selecionado");
        }

      },
      () => console.log("Get States")
    );

  }

  deleteVisit() {
    console.log("visita selecionada", this.lsVisitsChecked);

    let data = [];

    let deleteBool = false;

    this.lsVisitsChecked.forEach(element => {

      console.log("satustus", element.idStatusVisita);
      console.log("dtPrev check", element.dataPrev)

      let novaDataVisita = '';

      if(element.novaDataVisita){
        novaDataVisita = moment(element.novaDataVisita, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD')
      }

      //if(element.idStatusVisita == 17){
      const visita = {
        IdFilialEmpr: 1,
        IdCli: element.idCliente,
        DtPrevVisita:  moment(element.dataPrev, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD'),
        IdStatusVisitaCli: element.idStatusVisita,
        DtIncl: new Date().toISOString(),
        InVisitaPrev: "S",
        IdSetorComc: this.userLogado.idSetor,
        IdVnd: this.userLogado.id,
        InOrder: parseInt(element.inOrder),
        IdFormaVisita: element.idFormaVisita
      }

      if(element.novaDataVisita){
        data.push({
          visita,
          edicao: false,
          novaDataVisita
        });

        deleteBool = true;
      }else{
        data.push({
          visita,
          edicao: false
        });

        deleteBool = true;
      }
      console.log("visita preenchida para deletar", visita)
      //}

    });

    let params = {
      visitas: []
    };
    params.visitas = data;

    this.isFormVisitRequesting = true;

    if (deleteBool) {
      const start = moment(this.diasSemana[0], "DD/MM/YYYY");
      const end = moment(this.diasSemana[this.diasSemana.length - 1], "DD/MM/YYYY");

      // Filtra apenas as visitas que PODEM ser excluídas
      // const visitasPermitidas = data.filter(item => {
      //   const dataPrev = moment(item.visita.DtPrevVisita, "YYYY-MM-DD");
      //   const bloqueada =
      //     dataPrev.isSameOrAfter(start) &&
      //     dataPrev.isSameOrBefore(end) &&
      //     item.visita.IdStatusVisitaCli == 17;

      //   return !bloqueada;
      // });

      const visitasPermitidas = data.filter(item => {
        const dataPrev = moment(item.visita.DtPrevVisita, "YYYY-MM-DD");

        const cond1 = dataPrev.isSameOrAfter(start);
        const cond2 = dataPrev.isSameOrBefore(end);
        const cond3 = Number(item.visita.IdStatusVisitaCli) === 17;

        console.log("------- TESTANDO ITEM -------");
        console.log("VISITA:", item.visita);
        console.log("dataPrev:", dataPrev.format("YYYY-MM-DD"));
        console.log("start:", start.format("YYYY-MM-DD"));
        console.log("end:", end.format("YYYY-MM-DD"));
        console.log("cond1 (>= start):", cond1);
        console.log("cond2 (<= end):", cond2);
        console.log("cond3 (status == 17):", cond3);

        const bloqueada = cond1 && cond2 && cond3;

        console.log("BLOQUEADA?:", bloqueada);

        return bloqueada;
      });

      // Verifica se há alguma bloqueada só pra avisar o usuário
      const totalBloqueadas = data.length - visitasPermitidas.length;

      if (totalBloqueadas > 0) {
        toastr.warning(`${totalBloqueadas} visita(s) não puderam ser excluídas por já estarem transmitidas.`);
      }

      if (visitasPermitidas.length === 0) {
        toastr.error("Nenhuma visita pôde ser excluída.");
        this.isFormVisitRequesting = false;
        return;
      }

      // Atualiza params.visitas com apenas as permitidas
      params.visitas = visitasPermitidas;

      // Agora exclui as permitidas
      this.visitService.deleteVisita(params).subscribe(
        data => {
          this.isFormVisitRequesting = false;
          toastr.success("Visita(s) excluída(s) com sucesso");
          this.router.navigateByUrl('/visitas/home');
        },
        error => {
          console.log(error);
          this.isFormVisitRequesting = false;
          if (typeof error === 'string') {
            toastr.error(error);
          } else {
            toastr.error("Falha ao excluir a(s) visita(s)");
          }
        }
      );
    }


    //jeito antigo para baixo
    // if(deleteBool){
    //   //proxima Semana
    // let start = moment(this.diasSemana[0], "DD/MM/YYYY");
    // let end = moment(this.diasSemana[this.diasSemana.length - 1], "DD/MM/YYYY")
    // let dataPrev = moment(data[0].visita.DtPrevVisita, "YYYY-MM-DD");

    // if (dataPrev.isSameOrAfter(start) && dataPrev.isSameOrBefore(end) && data[0].visita.IdStatusVisitaCli == 17) {
    //   toastr.error("Não é possível excluir uma visita transmitida");
    // } else {
    //   this.visitService.deleteVisita(params).subscribe(
    //     data => {
    //       this.isFormVisitRequesting = false;
    //       toastr.success("Visita excluida com sucesso");
    //       this.router.navigateByUrl('/visitas/home');
    //     },
    //     error => {
    //       console.log(error);
    //       this.isFormVisitRequesting = false;

    //       if(typeof error === 'string'){
    //         toastr.error(error);
    //       }else{
    //         toastr.error("Falha ao excluir a visita");
    //       }

    //     },
    //     () => console.log("Get States")
    //   );
    // }
    //   // this.visitService.deleteVisita(params).subscribe(
    //   //   data => {
    //   //     this.isFormVisitRequesting = false;
    //   //     toastr.success("Visita excluida com sucesso");
    //   //     this.router.navigateByUrl('/visitas/home');
    //   //   },
    //   //   error => {
    //   //     console.log(error);
    //   //     this.isFormVisitRequesting = false;

    //   //     if(typeof error === 'string'){
    //   //       toastr.error(error);
    //   //     }else{
    //   //       toastr.error("Falha ao excluir a visita");
    //   //     }

    //   //   },
    //   //   () => console.log("Get States")
    //   // );
    // }//else{
      //toastr.error("Não é possível excluir uma visita transmitida");
    //}


    console.log(this.visitDay);

  }


}
